module.exports = __webpack_public_path__ + "7f0b49e40bc10021b59e34110096d0a0.svg";